import BannerA from '../../components/BannerA';
import FaqA from '../../components/FaqA';
import GoodsA1 from '../../components/GoodsA1';
import ListA2 from '../../components/ListA2';
import Footer from '../../components/FooterTcA';
import SectionA2U from '../../components/SectionA2U';
import SectionA3 from '../../components/SectionA3';
import SectionA5 from '../../components/SectionA5';
import SectionA6 from '../../components/SectionA6';
import SectionA8 from '../../components/SectionA8';
import SectionB2 from '../../components/SectionB2';
import SectionU1 from '../../components/SectionU1';
// import SectionU2 from '../../components/SectionU2';
import SectionU21 from '../../components/SectionU21';
import SectionU3 from '../../components/SectionU3';

export default function StatusItem() {
    return (
        <>
            <BannerA />
            <SectionU21 />
            <SectionU1 />
            <GoodsA1 />
            <SectionA2U />
            <SectionB2 />
            <ListA2 />
            <SectionU3 />
            <SectionA3 />
            {/* <SectionA5 /> */}
            {/* <SectionA6 /> */}
            <FaqA />
            <SectionA8 />
            <Footer />
        </>
    );
}
